var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.55 16.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M525.15,79.65a8.8,8.8,0,0,0-.45,2.8,7.88,7.88,0,0,0,2.5,6.15v0a11.63,11.63,0,0,0,1.35,1.15,2.15,2.15,0,0,0,1.1.2,1.43,1.43,0,0,0,.8-0.6,1.2,1.2,0,0,0,.2-1.05,1,1,0,0,0-.55-0.85q-0.45-.35-0.95-0.8a5.25,5.25,0,0,1-1.7-4.1V82.45a6.6,6.6,0,0,1,.3-2,6,6,0,0,1,1.4-2.3l-0.05.1a6,6,0,0,1,4.25-1.7h0.05a5.35,5.35,0,0,1,4.1,1.6h0a7,7,0,0,1,1.8,4.2q-0.1.55-.15,1.05l-4.7-2.35,4.15,7.9a0.5,0.5,0,0,1,.2.2V89l8.4-5.55-5.35.3a6.44,6.44,0,0,0,.2-1.2v-0.1a8.59,8.59,0,0,0-2.65-6.15V76.25a7.78,7.78,0,0,0-6.1-2.5h0a8.63,8.63,0,0,0-6.1,2.5h-0.1a8.83,8.83,0,0,0-1.95,3.35v0.05Z",
    transform: "translate(-524.7 -73.74)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.bf27b804.svg";
export { ForwardRef as ReactComponent };